import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { Row, Col, Container, Spinner } from "react-bootstrap";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import "./ControlMeasures.css";
import ControlMeasureSearch from "../../components/UI/ControlMeasureSearch/ControlMeasureSearch";
import axiosInstance from "../../api/utils/axiosInstance";
import moment from "moment";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import Badge from "react-bootstrap/Badge";
import ControlMeasuresPregled from "../../components/ControlMeasures/ControlMeasuresPregled";
import { FormOutlined } from "@ant-design/icons";
import { Pagination, message } from "antd";

class controlMeasures extends Component {
  state = {
    modal: false,
    modalNapomena: false,
    modalDat: false,
    modalPregled: false,
    modalObrisi: false,
    modalUpravniSpor: false,
    modalPP: false,
    modalDatBrisanja: false,
    modalDatDostave: false,
    modalTitle: "Unos datuma pravomoćnosti",
    modalTitleAddMeasure: "Unos nadzorne mjere",
    table: false,

    oib: "",
    regNumber: "",
    subjectName: "",
    nameSurname: "",
    surName: "",
    class: "",
    mbs: "",
    pageNumber: 1,
    offset: 10,
    napomena: "",
    vrstaDokumenta: null,
    formData: {
      measuretype: null,
      idSubjekta: null,
      document: "",
      solutionNum: null,
      solutionDat: "",
      downloadDat: "",
      note: "",
      datPravomocnosti: "",
      selectedFile: [],
      sts: "",
    },

    formDataUS: {
      idSubjekta: null,
      solutionNum: null,
      solutionDat: "",
      downloadDat: "",
      note: "",
      datPravomocnosti: "",
      selectedFile: [],
      sts: "",
    },

    formDataPP: {
      idSubjekta: null,
      solutionNum: null,
      solutionDat: "",
      downloadDat: "",
      note: "",
      datPravomocnosti: "",
      selectedFile: [],
      sts: "",
    },

    savedData: false,
    dropDownData: [],
    revisorData: [],
    measureData: [],
    measureDocData: [],
    idSubjekta: "",
    idOsobe: "",
    idDrustva: "",
    idMjereSubjekta: "",
    vrstaRegistra: null,
    error: false,
    attachment: [],
    revisorListdata: [],
    totalPageCount: 0,
    dataFetched: false,
    isLoading: true,
    isListLoading: true,
    isEnabled: false,
    isMeasureEdit: false,
    updated: false,
    datBrisanja: "",
    datPreuzimanja: "",
    loader: false,
    loaderBrisanje: false,
    measureDataDeleted: [],
    tableDeleted: false,
  };

  componentDidMount = () => {
    this.getMeasures();
    this.getAllRevisors();
  };

  getAllRevisors() {
    this.setState(
      {
        ...this.state,
        oib: "",
        regNumber: "",
        subjectName: "",
        nameSurname: "",
        surName: "",
        class: "",
        mbs: "",
        pageNumber: 1,
        offset: 10,
      },
      () => {
        axiosInstance
          .get(
            `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=1&offset=10`
          )
          .then((res) => {
            this.setState({
              revisorData: res.data,
              totalPageCount: res.data[0]?.totalRows,
              error: false,
              isListLoading: false,
              isLoading: false,
            });
          });
      }
    );
  }

  getMeasures() {
    try {
      axiosInstance.get("/controlMeasures").then((res) => {
        this.setState(
          {
            dropDownData: res.data,
          },
          () => {}
        );
      });
    } catch (e) {
      throw e;
    }
  }

  //HANDLERI
  userInputHandler = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState({ ...this.state, [id]: value });
  };

  userInputFormHandler = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [id]: value,
      },
    }));
  };

  userInputFormHandlerUS = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState((prevState) => ({
      formDataUS: {
        ...prevState.formDataUS,
        [id]: value,
      },
    }));
  };

  userInputFormHandlerPP = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState((prevState) => ({
      formDataPP: {
        ...prevState.formDataPP,
        [id]: value,
      },
    }));
  };

  userInputNapomena = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    this.setState({
      [id]: value,
    });
  };

  mjereDropDownHandler = (e) => {
    e.persist();
    const measuretype = e.target.value;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        measuretype,
      },
    }));
  };

  datePickerHandler = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        [objData.id]: selectedDate,
      },
    });
  };

  datePickerHandlerUS = (day, objData) => {
    const selectedDate = moment(day).format();
    this.setState({
      ...this.state,
      formDataUS: {
        ...this.state.formDataUS,
        [objData.id]: selectedDate,
      },
    });
  };

  datePickerHandlerPP = (day, objData) => {
    const selectedDate = moment(day).format("DD.MM.YYYY");
    this.setState({
      ...this.state,
      formDataPP: {
        ...this.state.formDataPP,
        [objData.id]: selectedDate,
      },
    });
  };

  datePickerHandlerDB = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState({
      ...this.state,
      [objData.id]: selectedDate,
    });
  };
  datePickerHandlerDD = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState({
      ...this.state,
      [objData.id]: selectedDate,
    });
  };

  //MODALI
  //za dodavanje mjera
  openModal = async (
    e,
    nadzornaMjera,
    idMjereOsobe,
    idMjereDrustva,
    element,
    isMeasureEdit
  ) => {
    e.preventDefault();
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      if (nadzornaMjera === null) {
        this.setState({
          ...this.state,
          modal: true,
          error: false,
          formData: {
            measuretype: null,
            document: "",
            solutionNum: null,
            solutionDat: "",
            downloadDat: "",
            note: "",
            datPravomocnosti: "",
            selectedFile: [],
          },
          isMeasureEdit: false,
        });
      } else {
        this.setState(
          {
            ...this.state,
            modal: true,
            error: false,
            formData: {
              measuretype: element.idMjere,
              document: "",
              solutionNum: element.brRjesenja,
              solutionDat: element.datRjesenja,
              downloadDat: element.datPravomocnosti,
              note: element.napomena,
              datPravomocnosti: element.datPravomocnosti,
              selectedFile: [],
            },
            isMeasureEdit: true,
            idMjereSubjekta: idMjereOsobe,
          },
          () => {
            axiosInstance
              .get(
                `/controlMeasures/dokumentMjera?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=1`
              )
              .then((res) => {
                let selectedFiles = {
                  id: "testId",
                  key: "test",
                  file: null,
                  name: res.data.nazDok,
                  uid: "<rc-update>",
                };

                let setSelectedFiles = [...this.state.formData.selectedFile];
                setSelectedFiles = [];
                setSelectedFiles.push(selectedFiles);
                this.setState({
                  ...this.state,
                  formData: {
                    ...this.state.formData,
                    selectedFile: setSelectedFiles,
                  },
                });
              });
          }
        );
      }
    } else {
      if (nadzornaMjera === null) {
        this.setState({
          ...this.state,
          modal: true,
          error: false,
          formData: {
            measuretype: null,
            document: "",
            solutionNum: null,
            solutionDat: "",
            downloadDat: "",
            note: "",
            datPravomocnosti: "",
            selectedFile: [],
          },
          isMeasureEdit: false,
        });
      } else {
        this.setState(
          {
            ...this.state,
            modal: true,
            error: false,
            formData: {
              measuretype: element.idMjere,
              document: "",
              solutionNum: element.brRjesenja,
              solutionDat: element.datRjesenja,
              downloadDat: element.datPravomocnosti,
              note: element.napomena,
              datPravomocnosti: element.datPravomocnosti,
              selectedFile: [],
            },
            isMeasureEdit: true,
            idMjereSubjekta: idMjereDrustva,
          },
          () => {
            axiosInstance
              .get(
                `/controlMeasures/dokumentMjera?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=1`
              )
              .then((res) => {
                let selectedFiles = {
                  id: "testId",
                  key: "test",
                  file: null,
                  name: res.data.nazDok,
                  uid: "<rc-update>",
                };

                let setSelectedFiles = [...this.state.formData.selectedFile];
                setSelectedFiles = [];
                setSelectedFiles.push(selectedFiles);
                this.setState({
                  ...this.state,
                  formData: {
                    ...this.state.formData,
                    selectedFile: setSelectedFiles,
                  },
                });
              });
          }
        );
      }
    }
  };

  hideModal = () => {
    this.setState({
      ...this.state,
      modal: false,
      formData: {
        measuretype: "",
        solutionNum: "",
        solutionDat: "",
        downloadDat: "",
        note: "",
        selectedFile: [],
      },
      isMeasureEdit: false,
    });
  };

  openModalUpravniSpor = (
    e,
    idSubjekta,
    idOsobe,
    idDrustva,
    idMjereOsobe,
    idMjereDrustva
  ) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      idSubjekta: idSubjekta,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      this.setState({
        ...this.state,
        modalUpravniSpor: true,
        error: false,
        idSubjekta: idOsobe,
        idMjereSubjekta: idMjereOsobe,
        formDataUS: {
          measuretype: null,
          document: "",
          solutionNum: null,
          solutionDat: "",
          downloadDat: "",
          note: "",
          datPravomocnosti: "",
          selectedFile: [],
        },
        isMeasureEdit: false,
      });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      this.setState({
        ...this.state,
        modalUpravniSpor: true,
        error: false,
        idSubjekta: idDrustva,
        idMjereSubjekta: idMjereDrustva,
        formDataUS: {
          measuretype: null,
          document: "",
          solutionNum: null,
          solutionDat: "",
          downloadDat: "",
          note: "",
          datPravomocnosti: "",
          selectedFile: [],
        },
        isMeasureEdit: false,
      });
    }
  };

  hideModalUpravniSpor = () => {
    this.setState({
      ...this.state,
      modalUpravniSpor: false,
      formDataUS: {
        measuretype: "",
        solutionNum: "",
        solutionDat: "",
        downloadDat: "",
        note: "",
        selectedFile: [],
      },
    });
  };

  openModalPP = (
    e,
    idSubjekta,
    idOsobe,
    idDrustva,
    idMjereOsobe,
    idMjereDrustva
  ) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      idSubjekta: idSubjekta,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      this.setState({
        ...this.state,
        modalPP: true,
        error: false,
        idSubjekta: idOsobe,
        idMjereSubjekta: idMjereOsobe,
        formDataPP: {
          measuretype: null,
          document: "",
          solutionNum: null,
          solutionDat: "",
          downloadDat: "",
          note: "",
          datPravomocnosti: "",
          selectedFile: [],
        },
        isMeasureEdit: false,
      });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      this.setState({
        ...this.state,
        modalPP: true,
        error: false,
        idSubjekta: idDrustva,
        idMjereSubjekta: idMjereDrustva,
        formDataPP: {
          measuretype: null,
          document: "",
          solutionNum: null,
          solutionDat: "",
          downloadDat: "",
          note: "",
          datPravomocnosti: "",
          selectedFile: [],
        },
        isMeasureEdit: false,
      });
    }
  };

  hideModalPP = () => {
    this.setState({
      ...this.state,
      modalPP: false,
      formDataPP: {
        measuretype: "",
        solutionNum: "",
        solutionDat: "",
        downloadDat: "",
        note: "",
        selectedFile: [],
      },
    });
  };

  openModalNapomena = (
    e,
    idSubjekta,
    idOsobe,
    idDrustva,
    idMjereOsobe,
    idMjereDrustva,
    vrDokumenta,
    staraNapomena
  ) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      idSubjekta: idSubjekta,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      this.setState({
        ...this.state,
        modalNapomena: true,
        idSubjekta: idOsobe,
        idMjereSubjekta: idMjereOsobe,
        vrstaDokumenta: vrDokumenta,
        napomena: staraNapomena,
      });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      this.setState({
        ...this.state,
        modalNapomena: true,
        idSubjekta: idDrustva,
        idMjereSubjekta: idMjereDrustva,
        vrstaDokumenta: vrDokumenta,
        napomena: staraNapomena,
      });
    }
  };

  hideModalNapomena = () => {
    this.setState({
      ...this.state,
      modalNapomena: false,
      napomena: "",
    });
  };

  //za datum pravomocnosti
  openModalDatPravomocnosti = (
    idSubjekta,
    idMjereOsobe,
    idMjereDrustva,
    idOsobe,
    idDrustva
  ) => {
    this.setState({
      ...this.state,
      formData: { ...this.state, datPravomocnosti: "" },
      modalDat: true,
      idSubjekta: idSubjekta,
      datPravomocnosti: "",
      error: false,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        this.setState({
          ...this.state,
          modalDat: true,
          idSubjekta: idOsobe,
          idMjereSubjekta: idMjereOsobe,
          datPravomocnosti: "",
          error: false,
          formData: {
            measuretype: "",
            solutionNum: "",
            solutionDat: "",
            downloadDat: "",
            note: "",
            selectedFile: "",
            datPravomocnosti: "",
          },
        });
      } catch (e) {
        throw e;
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        this.setState({
          ...this.state,
          modalDat: true,
          idSubjekta: idDrustva,
          idMjereSubjekta: idMjereDrustva,
          datPravomocnosti: "",
          error: false,
          formData: {
            measuretype: "",
            solutionNum: "",
            solutionDat: "",
            downloadDat: "",
            note: "",
            selectedFile: "",
            datPravomocnosti: "",
          },
        });
      } catch (e) {
        throw e;
      }
    }
  };

  hideModalDat = () => {
    this.setState({
      ...this.state,
      modalDat: false,
      datPravomocnosti: "",
    });
  };

  //pregled
  openModalPregled = (idSubjekta, vrstaRegistra) => {
    this.setState({
      modalPregled: true,
      idSubjekta: idSubjekta,
      vrstaRegistra: vrstaRegistra,
    });
  };

  hideModalPregled = () => {
    this.setState(
      {
        ...this.state,
        modalPregled: false,
      },
      () => {
        axiosInstance
          .get(
            `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=${this.state.pageNumber}&offset=10`
          )
          .then((res) => {
            this.setState({
              revisorData: res.data,
              totalPageCount: res.data[0].totalRows,
              error: false,
              isListLoading: false,
            });
          });
      }
    );
  };

  //za brisanje
  openModalObrisi = (idSubjekta, idMjereOsobe, idMjereDrustva) => {
    this.setState({
      ...this.state,
      modalObrisi: true,
      idSubjekta: idSubjekta,
      error: false,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        this.setState({
          ...this.state,
          modalObrisi: true,
          idMjereSubjekta: idMjereOsobe,
          error: false,
        });
      } catch (e) {
        throw e;
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        this.setState({
          ...this.state,
          modalObrisi: true,
          idMjereSubjekta: idMjereDrustva,
          error: false,
        });
      } catch (e) {
        throw e;
      }
    }
  };

  hideModalObrisi = () => {
    this.setState({
      ...this.state,
      modalObrisi: false,
    });
  };

  //za datum brisanja
  openModalUnosDatBrisanja = (
    idSubjekta,
    idMjereOsobe,
    idMjereDrustva,
    idOsobe,
    idDrustva
  ) => {
    this.setState({
      ...this.state,
      modalDatBrisanja: true,
      idSubjekta: idSubjekta,
      datBrisanja: "",
      error: false,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        this.setState({
          ...this.state,
          modalDatBrisanja: true,
          idSubjekta: idOsobe,
          idMjereSubjekta: idMjereOsobe,
          datBrisanja: "",
          error: false,
        });
      } catch (e) {
        throw e;
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        this.setState({
          ...this.state,
          modalDatBrisanja: true,
          idSubjekta: idDrustva,
          idMjereSubjekta: idMjereDrustva,
          datBrisanja: "",
          error: false,
        });
      } catch (e) {
        throw e;
      }
    }
  };

  hideModalUnosDatBrisanja = () => {
    this.setState({
      ...this.state,
      modalDatBrisanja: false,
      datBrisanja: "",
    });
  };

  //za datum brisanja
  openModalUnosDatDostave = (
    idSubjekta,
    idMjereOsobe,
    idMjereDrustva,
    idOsobe,
    idDrustva
  ) => {
    this.setState({
      ...this.state,
      modalDatDostave: true,
      idSubjekta: idSubjekta,
      datPreuzimanja: "",
      error: false,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        this.setState({
          ...this.state,
          modalDatDostave: true,
          idSubjekta: idOsobe,
          idMjereSubjekta: idMjereOsobe,
          datPreuzimanja: "",
          error: false,
        });
      } catch (e) {
        throw e;
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        this.setState({
          ...this.state,
          modalDatDostave: true,
          idSubjekta: idDrustva,
          idMjereSubjekta: idMjereDrustva,
          datPreuzimanja: "",
          error: false,
        });
      } catch (e) {
        throw e;
      }
    }
  };

  hideModalUnosDatDostave = () => {
    this.setState({
      ...this.state,
      modalDatDostave: false,
      datPreuzimanja: "",
    });
  };

  //dodavanje mjera
  submitHandler = (e, idMjereSubjekta) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      table: false,
      loader: true,
    });

    const { measuretype, solutionDat, solutionNum, downloadDat, note } =
      this.state.formData;

    const addMeasureOsoba = {
      idMjere: measuretype,
      idOsobe: this.state.idSubjekta,
      brRjesenja: solutionNum,
      datRjesenja: solutionDat,
      datPravomocnosti: downloadDat,
      napomena: note,
    };

    const addMeasureDrustva = {
      idMjere: measuretype,
      idDrustva: this.state.idSubjekta,
      brRjesenja: solutionNum,
      datRjesenja: solutionDat,
      datPravomocnosti: downloadDat,
      napomena: note,
    };

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    //OSOBA
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      if (
        this.state.formData.selectedFile.length > 0 &&
        this.state.formData.measuretype &&
        this.state.formData.solutionDat &&
        this.state.formData.solutionNum && 
        this.state.formData.solutionNum.length <= 20
      ) {
        if (this.state.isMeasureEdit === false) {
          try {
            axiosInstance
              .post(
                `/controlMeasures/controlMeasurePerson?vrOsobe=${this.state.vrstaRegistra}`,
                addMeasureOsoba
              )
              .then((res) => {
                this.setState(
                  {
                    savedData: true,
                    idMjereSubjekta: res.data.idMjereOsobe,
                    measureDocData: res.data,
                    idSubjekta: res.data.idOsobe,
                  },
                  () => {
                    const { idSubjekta } = this.state;

                    //za dokument
                    if (this.state.formData.selectedFile.length > 0) {
                      try {
                        const uploadNewFiles =
                          this.state.formData.selectedFile.map(
                            async (element) => {
                              const formData = new FormData();
                              const { idMjereSubjekta, isMeasureEdit } =
                                this.state;

                              formData.append("file", element.file);
                              formData.append(
                                "idMjereSubjekta",
                                idMjereSubjekta
                              );
                              formData.append("vrSubjekta", 1);
                              formData.append("isEdit", isMeasureEdit);

                              const response = await axiosInstance.post(
                                "/controlMeasures/upload/attachment",
                                formData
                              );
                            }
                          );
                      } catch (e) {
                        throw e;
                      }
                    }

                    axiosInstance
                      .get(
                        `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=${this.state.pageNumber}&offset=10`
                      )
                      .then((res) => {
                        this.setState(
                          {
                            revisorData: res.data,
                            totalPageCount: res.data[0].totalRows,
                            error: false,
                            isListLoading: false,
                            modal: false,
                            loader: false,
                          },
                          () => {
                            this.props.formSubmitSuccess(
                              false,
                              "Podaci o nadzornoj mjeri uspješno upisani!"
                            );
                            this.showTable(idSubjekta);
                          }
                        );
                      });
                  }
                );
              });
          } catch (e) {
            this.setState(
              {
                loader: false,
              },
              () => {
                this.props.formSubmitSuccess(false, "Nešto je pošlo po krivu!");
              }
            );
            throw e;
          }
        } else {
          this.updateMeasure(idMjereSubjekta);
        }
      } else {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const {
        note,
        downloadDat,
        measuretype,
        selectedFile,
        solutionNum,
        solutionDat,
      } = this.state.formData;

      if (
        !measuretype ||
        !solutionDat ||
        !solutionNum ||
        selectedFile.length === 0
      ) {
        this.setState(
          {
            error: true,
          },
          () => {
            this.props.formSubmitError(true, "Popunite obavezna polja!");
          }
        );
        return;
      }else if(
        solutionNum.length > 20
      ){
          this.setState(
            {
              error: true,
            },
            ()=>{
              this.props.formSubmitError(true, "Maksimalan broj znakova pri unosu je 20");
            }
          );
          return;
      } else {
        this.setState(
          {
            table: true,
            formData: {
              measuretype: measuretype,
              solutionNum: solutionNum,
              solutionDat: solutionDat,
              downloadDat: downloadDat,
              note: note,
              selectedFile: selectedFile,
            },
          },
          () => {}
        );
      }

      //DRUSTVO
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      if (
        this.state.formData.selectedFile.length > 0 &&
        this.state.formData.measuretype &&
        this.state.formData.solutionDat && 
        this.state.formData.solutionNum &&
        this.state.formData.solutionNum.length <= 20
      ) {
        if (this.state.isMeasureEdit === false) {
          try {
            axiosInstance
              .post(
                `/controlMeasures/controlMeasureDrustvo?vrDrustva=${this.state.vrstaRegistra}`,
                addMeasureDrustva
              )
              .then((res) => {
                this.setState(
                  {
                    savedData: true,
                    measureDocData: res.data,
                    idMjereSubjekta: res.data.idMjereDrustva,
                    idSubjekta: res.data.idDrustva,
                  },
                  async () => {
                    const { idSubjekta } = this.state;

                    //za dokument
                    if (this.state.formData.selectedFile.length > 0) {
                      try {
                        const uploadNewFiles =
                          this.state.formData.selectedFile.map(
                            async (element) => {
                              const formData = new FormData();
                              const { idMjereSubjekta, isMeasureEdit } =
                                this.state;
                              formData.append("file", element.file);

                              formData.append(
                                "idMjereSubjekta",
                                idMjereSubjekta
                              );
                              formData.append("vrSubjekta", 2);
                              formData.append("vrDokumenta", 1);
                              formData.append("isEdit", isMeasureEdit);

                              const response = await axiosInstance.post(
                                "/controlMeasures/upload/attachment",
                                formData
                              );
                            }
                          );
                      } catch (e) {
                        this.props.formSubmitError(
                          true,
                          "Nešto je pošlo po krivu!"
                        );
                      }
                    }

                    await axiosInstance
                      .get(
                        `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=${this.state.pageNumber}&offset=10`
                      )
                      .then((res) => {
                        this.setState(
                          {
                            revisorData: res.data,
                            totalPageCount: res.data[0].totalRows,
                            error: false,
                            isListLoading: false,
                            modal: false,
                            loader: false,
                          },
                          () => {
                            this.props.formSubmitSuccess(
                              false,
                              "Podaci o nadzornoj mjeri uspješno upisani!"
                            );
                            this.showTable(idSubjekta);
                          }
                        );
                      });
                  }
                );
              });
          } catch (e) {
            this.setState(
              {
                loader: false,
              },
              () => {
                this.props.formSubmitSuccess(false, "Nešto je pošlo po krivu!");
              }
            );
            throw e;
          }
        } else {
          this.updateMeasure(idMjereSubjekta);
        }
      } else {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const {
        note,
        download,
        measuretype,
        selectedFile,
        solutionNum,
        solutionDat,
      } = this.state.formData;
      const { idSubjekta } = this.state;

      if (
        !measuretype ||
        !solutionDat ||
        !solutionNum ||
        selectedFile.length === 0
      ) {
        this.setState(
          {
            error: true,
          },
          () => {
            this.props.formSubmitError(true, "Popunite obavezna polja!");
          }
        );

        return;
      }else if(
        solutionNum.length > 20
      ){
          this.setState(
            {
              error: true,
            },
            ()=>{
              this.props.formSubmitError(true, "Maksimalan broj znakova pri unosu je 20");
            }
          );
          return;
      } else {
        this.setState({
          table: true,
          formData: {
            measuretype: measuretype,
            solutionNum: solutionNum,
            solutionDat: solutionDat,
            downloadDat: downloadDat,
            note: note,
            selectedFile: selectedFile,
          },
        });
      }
    }
  };

  //dodavanje US
  submitHandlerUS = async (e, idSubjekta, idMjereOsobe, idMjereDrustva) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      table: false,
      idSubjekta: idSubjekta,
    });
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    //OSOBA
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      if (
        this.state.formDataUS.selectedFile.length > 0 ||
        this.state.formDataUS.note != ""
      ) {
        this.setState({
          ...this.state,
          table: false,
          idMjereSubjekta: idMjereOsobe,
        });

        try {
          if (this.state.formDataUS.selectedFile.length > 0) {
            const uploadNewFiles = this.state.formDataUS.selectedFile.map(
              async (element) => {
                const formData = new FormData();
                const { idMjereSubjekta } = this.state;
                const { idSubjekta } = this.state;
                const { note } = this.state.formDataUS;
                formData.append("file", element.file);

                formData.append("idMjereSubjekta", idMjereSubjekta);
                formData.append("vrSubjekta", 1);
                formData.append("vrDokumenta", 2);
                formData.append("napomena", note);

                const response = await axiosInstance.post(
                  "/controlMeasures/uploadUSiliPP/attachment",
                  formData
                );
                this.showTable(idSubjekta);
              }
            );
          } else {
            const formData = new FormData();
            const { idMjereSubjekta } = this.state;
            const { idSubjekta } = this.state;
            const { note } = this.state.formDataUS;

            formData.append("idMjereSubjekta", idMjereSubjekta);
            formData.append("vrSubjekta", 1);
            formData.append("vrDokumenta", 2);
            formData.append("napomena", note);

            const response = await axiosInstance.post(
              "/controlMeasures/uploadUSiliPP/napomena",
              formData
            );
            this.showTable(idSubjekta);
          }
        } catch (e) {
          this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
        }

        //  this.showTable(idSubjekta);
      } else if (
        this.state.formDataUS.selectedFile.length === 0 &&
        this.state.formDataUS.note === ""
      ) {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const { selectedFile } = this.state.formDataUS;

      if (selectedFile.length === 0 && this.state.formDataUS.note === "") {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite dokument ili napomenu!");
        this.setState({
          modalUpravniSpor: true,
          table: true,
          modatPregled: true,
        });
        return;
      } else if (
        this.state.formDataUS.note &&
        this.state.formDataUS.note.length > 500
      ) {
        this.props.formSubmitError(
          true,
          "Tekst može sadržavati maximalno 500 znakova!"
        );
        this.setState({
          modalUpravniSpor: true,
          table: true,
          modatPregled: true,
        });
      } else {
        this.props.formSubmitSuccess(
          false,
          "Podaci o upravnom sporu uspješno upisani!"
        );
        this.setState({
          modalUpravniSpor: false,
          table: true,
          modatPregled: true,
        });
      }

      //DRUSTVO
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      if (
        this.state.formDataUS.selectedFile.length > 0 ||
        this.state.formDataUS.note != ""
      ) {
        this.setState({
          ...this.state,
          table: false,
          idMjereSubjekta: idMjereDrustva,
        });
        try {
          if (this.state.formDataUS.selectedFile.length > 0) {
            const uploadNewFiles = this.state.formDataUS.selectedFile.map(
              async (element) => {
                const formData = new FormData();
                const { idMjereSubjekta } = this.state;
                const { idSubjekta } = this.state;
                const { solutionNum, solutionDat, note, downloadDat } =
                  this.state.formDataUS;
                formData.append("file", element.file);

                formData.append("idMjereSubjekta", idMjereSubjekta);
                formData.append("vrSubjekta", 2);
                formData.append("vrDokumenta", 2);
                formData.append("napomena", note);

                const response = await axiosInstance.post(
                  "/controlMeasures/uploadUSiliPP/attachment",
                  formData
                );
                this.showTable(idSubjekta);
              }
            );
          } else {
            const formData = new FormData();
            const { idMjereSubjekta } = this.state;
            const { idSubjekta } = this.state;
            const { solutionNum, solutionDat, note, downloadDat } =
              this.state.formDataUS;

            formData.append("idMjereSubjekta", idMjereSubjekta);
            formData.append("vrSubjekta", 2);
            formData.append("vrDokumenta", 2);
            formData.append("napomena", note);

            const response = await axiosInstance.post(
              "/controlMeasures/uploadUSiliPP/napomena",
              formData
            );
            this.showTable(idSubjekta);
          }
        } catch (e) {
          this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
        }
      } else {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const { selectedFile } = this.state.formDataUS;

      if (selectedFile.length === 0 && this.state.formDataUS.note === "") {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite dokument ili napomenu!");
        this.setState({
          modalUpravniSpor: true,
          table: true,
          modatPregled: true,
        });
        return;
      } else if (
        this.state.formDataUS.note &&
        this.state.formDataUS.note.length > 500
      ) {
        this.props.formSubmitError(
          true,
          "Tekst može sadržavati maximalno 500 znakova!"
        );
        this.setState({
          modalUpravniSpor: true,
          table: true,
          modatPregled: true,
        });
      } else {
        this.props.formSubmitSuccess(
          false,
          "Podaci o upravnom sporu uspješno upisani!"
        );
        this.setState({
          modalUpravniSpor: false,
          table: true,
          modatPregled: true,
        });
      }
    }
  };

  //dodavanje PP
  submitHandlerPP = async (e, idSubjekta, idMjereOsobe, idMjereDrustva) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      table: false,
      idSubjekta: idSubjekta,
    });

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    //OSOBA
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      if (
        this.state.formDataPP.selectedFile.length > 0 ||
        this.state.formDataPP.note != ""
      ) {
        this.setState({
          ...this.state,
          table: false,
          idMjereSubjekta: idMjereOsobe,
        });

        try {
          if (this.state.formDataPP.selectedFile.length > 0) {
            const uploadNewFiles = this.state.formDataPP.selectedFile.map(
              async (element) => {
                const formData = new FormData();
                const { idMjereSubjekta } = this.state;
                const { idSubjekta } = this.state;
                const { solutionNum, solutionDat, note, downloadDat } =
                  this.state.formDataPP;
                formData.append("file", element.file);

                formData.append("idMjereSubjekta", idMjereSubjekta);
                formData.append("vrSubjekta", 1);
                formData.append("vrDokumenta", 3);
                formData.append("napomena", note);

                const response = await axiosInstance.post(
                  "/controlMeasures/uploadUSiliPP/attachment",
                  formData
                );
                this.showTable(idSubjekta);
              }
            );
          } else {
            const formData = new FormData();
            const { idMjereSubjekta } = this.state;
            const { idSubjekta } = this.state;
            const { note } = this.state.formDataPP;

            formData.append("idMjereSubjekta", idMjereSubjekta);
            formData.append("vrSubjekta", 1);
            formData.append("vrDokumenta", 3);
            formData.append("napomena", note);

            const response = await axiosInstance.post(
              "/controlMeasures/uploadUSiliPP/napomena",
              formData
            );
            this.showTable(idSubjekta);
          }
        } catch (e) {
          this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
        }
      } else {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const { selectedFile, note } = this.state.formDataPP;

      if (selectedFile.length === 0 && note === "") {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite dokument ili napomenu!");
        this.setState({ modalPP: true, table: true, modatPregled: true });
        return;
      } else if (
        this.state.formDataPP.note &&
        this.state.formDataPP.note.length > 500
      ) {
        this.props.formSubmitError(
          true,
          "Tekst može sadržavati maximalno 500 znakova!"
        );
        this.setState({ modalPP: true, table: true, modatPregled: true });
      } else {
        this.props.formSubmitSuccess(
          false,
          "Podaci o prekršajnom postupku uspješno upisani!"
        );
        this.setState({
          modalPP: false,
          table: true,
          modatPregled: true,
          //   formData: {
          //   measuretype: measuretype,
          //   solutionNum: solutionNum,
          //   solutionDat: solutionDat,
          //   downloadDat: downloadDat,
          //   note: note,
          //   selectedFile: selectedFile
          // }
        });
      }

      //DRUSTVO
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      if (
        this.state.formDataPP.selectedFile.length > 0 ||
        this.state.formDataPP.note != ""
      ) {
        this.setState({
          ...this.state,
          table: false,
          idMjereSubjekta: idMjereDrustva,
        });
        try {
          if (this.state.formDataPP.selectedFile.length > 0) {
            const uploadNewFiles = this.state.formDataPP.selectedFile.map(
              async (element) => {
                const formData = new FormData();
                const { idMjereSubjekta } = this.state;
                const { idSubjekta } = this.state;
                const { note } = this.state.formDataPP;
                formData.append("file", element.file);

                formData.append("idMjereSubjekta", idMjereSubjekta);
                formData.append("vrSubjekta", 2);
                formData.append("vrDokumenta", 3);
                formData.append("napomena", note);

                const response = await axiosInstance.post(
                  "/controlMeasures/uploadUSiliPP/attachment",
                  formData
                );
                this.showTable(idSubjekta);
              }
            );
          } else {
            const formData = new FormData();
            const { idMjereSubjekta } = this.state;
            const { idSubjekta } = this.state;
            const { note } = this.state.formDataPP;

            formData.append("idMjereSubjekta", idMjereSubjekta);
            formData.append("vrSubjekta", 2);
            formData.append("vrDokumenta", 3);
            formData.append("napomena", note);

            const response = await axiosInstance.post(
              "/controlMeasures/uploadUSiliPP/napomena",
              formData
            );
            this.showTable(idSubjekta);
          }
        } catch (e) {
          this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
        }
      } else {
        this.setState({
          ...this.state,
          selectedFile: [],
        });
      }

      //obavezna polja i ispis poruka
      const { selectedFile, note } = this.state.formDataPP;

      if (selectedFile.length === 0 && note === "") {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite dokument ili napomenu!");
        this.setState({ modalPP: true, table: true, modatPregled: true });
        return;
      } else if (
        this.state.formDataPP.note &&
        this.state.formDataPP.note.length > 500
      ) {
        this.props.formSubmitError(
          true,
          "Tekst može sadržavati maximalno 500 znakova!"
        );
        this.setState({ modalPP: true, table: true, modatPregled: true });
      } else {
        this.props.formSubmitSuccess(
          false,
          "Podaci o prekršajnom postupku uspješno upisani!"
        );
        this.setState({
          modalPP: false,
          table: true,
          modatPregled: true,
          //   formData: {
          //   measuretype: measuretype,
          //   solutionNum: solutionNum,
          //   solutionDat: solutionDat,
          //   downloadDat: downloadDat,
          //   note: note,
          //   selectedFile: selectedFile
          // }
        });
      }
    }
  };

  submitHandlerNapomena = (e) => {
    e.preventDefault();
    const { idMjereSubjekta, vrstaDokumenta, napomena, idSubjekta } =
      this.state;

    try {
      axiosInstance
        .patch(
          `/controlMeasures/update-napomena?idMjereSubjekta=${idMjereSubjekta}&vrDokumenta=${vrstaDokumenta}&napomena=${napomena}`
        )
        .then(
          (res) => {
            this.setState(
              {
                modalNapomena: false,
                modalPregled: true,
                napomena: "",
              },
              () => {
                this.showTable(idSubjekta);
              }
            );
          }
          // this.props.formSubmitSuccess(
          //   false,
          //   "Podaci o prekršajnom postupku uspješno upisani!"
          // )
        );
    } catch (error) {
      throw error;
      this.showTable(idSubjekta);
    }
  };

  //azuriranje mjera
  updateMeasure = (idMjereSubjekta) => {
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );
    const { measuretype, solutionDat, solutionNum, downloadDat, note } =
      this.state.formData;

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        const { formData } = this.state;
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/azuriranjeMjereOsoba?idMjereOsobe=${idMjereSubjekta}`,
            {
              idMjere: measuretype,
              brRjesenja: solutionNum,
              datRjesenja: solutionDat,
              datPravomocnosti: downloadDat,
              napomena: note,
              idMjereOsobe: idMjereSubjekta,
            }
          )
          .then((res) => {
            if (this.state.formData.selectedFile.length > 0) {
              try {
                const uploadNewFiles = this.state.formData.selectedFile.map(
                  async (element) => {
                    const formData = new FormData();
                    const { idMjereSubjekta, isMeasureEdit } = this.state;
                    const { idSubjekta } = this.state;
                    formData.append("file", element.file);

                    formData.append("idMjereSubjekta", idMjereSubjekta);
                    formData.append("vrSubjekta", 1);
                    formData.append("vrDokumenta", 1);
                    formData.append("isEdit", isMeasureEdit);

                    const response = await axiosInstance.post(
                      "/controlMeasures/upload/attachment",
                      formData
                    );
                  }
                );
              } catch (e) {
                this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
              }
            }

            this.setState(
              {
                modal: false,
                loader: false,
              },
              () => {
                this.props.formSubmitSuccess(
                  false,
                  "Podaci o nadzornoj mjeri uspješno ažurirani!"
                );

                this.showTable(idSubjekta);
              }
            );
          });
      } catch (e) {
        throw e;
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        const { formData } = this.state;
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/azuriranjeMjereDrustvo?idMjereDrustva=${idMjereSubjekta}`,
            {
              idMjere: measuretype,
              brRjesenja: solutionNum,
              datRjesenja: solutionDat,
              datPravomocnosti: downloadDat,
              napomena: note,
              idMjereDrustva: idMjereSubjekta,
            }
          )
          .then((res) => {
            if (this.state.formData.selectedFile.length > 0) {
              try {
                const uploadNewFiles = this.state.formData.selectedFile.map(
                  async (element) => {
                    const formData = new FormData();
                    const { idMjereSubjekta, isMeasureEdit } = this.state;
                    const { idSubjekta } = this.state;
                    formData.append("file", element.file);

                    formData.append("idMjereSubjekta", idMjereSubjekta);
                    formData.append("vrSubjekta", 2);
                    formData.append("vrDokumenta", 1);
                    formData.append("isEdit", isMeasureEdit);

                    const response = await axiosInstance.post(
                      "/controlMeasures/upload/attachment",
                      formData
                    );
                  }
                );
              } catch (e) {
                this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
              }
            }
            this.setState(
              {
                modal: false,
                loader: false,
              },
              () => {
                this.props.formSubmitSuccess(
                  false,
                  "Podaci o nadzornoj mjeri uspješno ažurirani!"
                );

                this.showTable(idSubjekta);
              }
            );
          });
      } catch (e) {
        throw e;
      }
    }
  };

  //SEARCH

  submitHandlerSearch = async (e) => {
    e.preventDefault();

    const { regNumber, oib, subjectName, nameSurname, surName, mbs } =
      this.state;

    const klasa = this.state.class;
    this.setState({
      isLoading: true
    });
    const res = await axiosInstance.get(
      `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=1&offset=10`
    );

    this.setState({
      revisorData: res.data,
      dataFetched: true,
      totalPageCount: res.data.length >0  ? res.data[0].totalRows : 0,
      error: false,
      isLoading: false
    });

    const { revisorData } = this.state;

    if (revisorData.length < 1) {
      //  this.setState({ error: true });
      this.props.formSubmitError(
        true,
        "Subjekt nije upisan u registar. Molimo provjerite upisane podatke za pretragu."
      );

      return;
    }
  };

  //PAGINACIJA
  pageChanged = async (pageNumber, pageSize) => {
    this.setState({
      isLoading: true,
      pageNumber: pageNumber,
    });

    const res = await axiosInstance(
      `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&mbs=${this.state.mbs}&page=${pageNumber}&offset=10`
    );

    this.setState({
      revisorData: res.data,
      isLoading: false,
      table: false,
    });
  };

  //prikaz tablice
  showTable = (idSubjekta) => {
    try {
      this.setState(
        {
          ...this.state,
          idSubjekta: idSubjekta,
        },
        () => {
          const findId = this.state.revisorData.find(
            (element) => element.idSubjekta === this.state.idSubjekta
          );

          const { idSubjekta } = this.state;

          //osoba
          if (findId.tipSubjekta === "OSOBA") {
            try {
              axiosInstance
                .get(`/controlMeasures/person/${idSubjekta}`)
                .then((res) => {
                  this.setState({
                    ...this.state,
                    measureData: res.data,
                    table: true,
                    idOsobe: idSubjekta,
                    oznAkt: findId.oznAkt,
                  });
                });
            } catch (e) {
              throw e;
            }
          }

          //drustvo
          else if (findId.tipSubjekta === "DRUSTVO") {
            try {
              axiosInstance
                .get(`/controlMeasures/drustvo/${idSubjekta}`)
                .then((res) => {
                  this.setState({
                    ...this.state,
                    measureData: res.data,
                    table: true,
                    idDrustva: idSubjekta,
                    oznAkt: findId.oznAkt,
                  });
                });
            } catch (e) {
              throw e;
            }
          } // end drustvo
        }
      );
    } catch (e) {
      throw e;
    }
  };

  //prikaz tablice za brisanje mjere
  showTableDeleted = (idSubjekta) => {
    try {
      this.setState(
        {
          ...this.state,
          idSubjekta: idSubjekta,
        },
        () => {
          const findId = this.state.revisorData.find(
            (element) => element.idSubjekta === this.state.idSubjekta
          );

          const { idSubjekta } = this.state;

          //osoba
          if (findId.tipSubjekta === "OSOBA") {
            try {
              axiosInstance
                .get(`/controlMeasures/person/deletedMeasures/${idSubjekta}`)
                .then((res) => {
                  this.setState({
                    ...this.state,
                    measureDataDeleted: res.data,
                    tableDeleted: true,
                    idOsobe: idSubjekta,
                    oznAkt: findId.oznAkt,
                  });
                });
            } catch (e) {
              throw e;
            }
          }

          //drustvo
          else if (findId.tipSubjekta === "DRUSTVO") {
            try {
              axiosInstance
                .get(`/controlMeasures/drustvo/deletedMeasures/${idSubjekta}`)
                .then((res) => {
                  this.setState({
                    ...this.state,
                    measureDataDeleted: res.data,
                    tableDeleted: true,
                    idDrustva: idSubjekta,
                    oznAkt: findId.oznAkt,
                  });
                });
            } catch (e) {
              throw e;
            }
          } // end drustvo
        }
      );
    } catch (e) {
      throw e;
    }
  };

  //DOKUMENT -MJERE
  //handler za upload dokumenta

  uploadHandler = (file, id) => {
    if (file.file.status === "removed") {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          selectedFile: [
            ...prevState.formData.selectedFile.filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
      return;
    }

    let selectedFiles = {
      id: id,
      file: null,
      name: file.file.name,
      uid: file.file.uid,
    };
    selectedFiles.file = file.file;

    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;
    if (file.file.size && !isFileLt10MB) {
      this.props.formSubmitError(
        false,
        "Nije dopušteno učitavanje datoteka većih od 10MB."
      );
      return;
    }
    let setSelectedFiles = [...this.state.formData.selectedFile];
    setSelectedFiles = [];
    setSelectedFiles.push(selectedFiles);
    this.setState({
      formData: {
        ...this.state.formData,
        selectedFile: setSelectedFiles,
      },
    });
  };

  uploadHandlerUS = (file, id) => {
    if (file.file.status === "removed") {
      this.setState((prevState) => ({
        formDataUS: {
          ...prevState.formDataUS,
          selectedFile: [
            ...prevState.formDataUS.selectedFile.filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
      return;
    }

    let selectedFiles = {
      id: id,
      file: null,
      name: file.file.name,
      uid: file.file.uid,
    };
    selectedFiles.file = file.file;

    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;
    if (file.file.size && !isFileLt10MB) {
      this.props.formSubmitError(
        false,
        "Nije dopušteno učitavanje datoteka većih od 10MB."
      );
      return;
    }

    let setSelectedFiles = [...this.state.formDataUS.selectedFile];
    setSelectedFiles = [];
    setSelectedFiles.push(selectedFiles);
    this.setState({
      formDataUS: {
        ...this.state.formDataUS,
        selectedFile: setSelectedFiles,
      },
    });
  };

  uploadHandlerPP = (file, id) => {
    if (file.file.status === "removed") {
      this.setState((prevState) => ({
        formDataPP: {
          ...prevState.formDataPP,
          selectedFile: [
            ...prevState.formDataPP.selectedFile.filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
      return;
    }

    let selectedFiles = {
      id: id,
      file: null,
      name: file.file.name,
      uid: file.file.uid,
    };
    selectedFiles.file = file.file;

    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;
    if (file.file.size && !isFileLt10MB) {
      this.props.formSubmitError(
        false,
        "Nije dopušteno učitavanje datoteka većih od 10MB."
      );
      return;
    }

    let setSelectedFiles = [...this.state.formDataPP.selectedFile];
    setSelectedFiles = [];
    setSelectedFiles.push(selectedFiles);
    this.setState({
      formDataPP: {
        ...this.state.formDataPP,
        selectedFile: setSelectedFiles,
      },
    });
  };

  //download dokumenta
  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  downloadDocument = (e, idMjereOsobe, idMjereDrustva) => {
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      const date = new Date();
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=1`
        )
        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereOsobe + "_nadzorna_mjera." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
            //dat preuzimanja
            // if (this.props.role === "ROLE_KORISNIK") {
            //   axiosInstance.patch(
            //     `/controlMeasures/saveDatPreuzimanjaPerson?idMjereOsobe=${idMjereOsobe}`,
            //     { datPreuzimanja: date, idMjereOsobe: idMjereOsobe }
            //   );
            // }
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      const date = new Date();
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=1`
        )

        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereDrustva + "_nadzorna_mjera." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
            //dat preuzimanja
            // if (this.props.role === "ROLE_KORISNIK") {
            //   axiosInstance.patch(
            //     `/controlMeasures/saveDatPreuzimanjaDrustvo?idMjereDrustva=${idMjereDrustva}`,
            //     { datPreuzimanja: date, idMjereDrustva: idMjereDrustva }
            //   );
            // }
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    }
  };
  downloadDocumentUS = (e, idMjereOsobe, idMjereDrustva) => {
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=2`
        )
        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereOsobe + "_upravni_spor." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=2`
        )

        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereDrustva + "_upravni_spor." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    }
  };
  downloadDocumentPP = (e, idMjereOsobe, idMjereDrustva) => {
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=3`
        )
        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereOsobe + "_prekrsajni_postupak." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      axiosInstance
        .get(
          `/controlMeasures/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=3`
        )

        .then((response) => {
          if (response.data.blob !== null) {
            const url = window.URL.createObjectURL(
              new Blob([this.b64toBlob(response.data.blob)])
            );
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
              "download",
              idMjereDrustva + "_prekrsajni_postupak." + response.data.extension
            );
            document.body.appendChild(link);
            link.click();
          } else {
            this.props.formSubmitError(true, "Dokument nije prenesen.");
          }
        });
    }
  };

  //unos datuma pravomocnosti
  submitHandlerDat = async (e, idSubjekta, idMjereOsobe, idMjereSubjekta) => {
    e.preventDefault();
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );
    // const {datPravomocnosti} = this.state;
    const { datPravomocnosti } = this.state.formData;
    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        const { datPravomocnosti } = this.state.formData;
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/editDatPravomocnostiPerson?idMjereOsobe=${idMjereSubjekta}`,
            {
              datPravomocnosti: datPravomocnosti,
              idMjereOsobe: idMjereSubjekta,
            }
          )
          .then((res) => {
            this.showTable(idSubjekta);
          });
      } catch (e) {
        throw e;
      }

      //obavezna polja i ispis poruka
      const { datPravomocnosti } = this.state.formData;

      if (!datPravomocnosti) {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Popunite obavezna polja!");
        this.setState({ modalDat: true });
        return;
      } else {
        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDat: false, table: true });
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        const { datPravomocnosti } = this.state.formData;
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/editDatPravomocnostiDrustvo?idMjereDrustva=${idMjereSubjekta}`,
            {
              datPravomocnosti: datPravomocnosti,
              idMjereDrustva: idMjereSubjekta,
            }
          )
          .then((res) => {
            this.showTable(idSubjekta);
          });
      } catch (e) {
        throw e;
      }

      //obavezna polja i ispis poruka
      const { datPravomocnosti } = this.state.formData;
      const { idSubjekta } = this.state;

      if (!datPravomocnosti) {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Popunite obavezna polja!");
        this.setState({ modalDat: true });
        return;
      } else {
        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDat: false });
      }
      this.showTable(idSubjekta);
    }
  };

  //unos datuma brisanja
  submitHandlerDatBrisanja = async (
    e,
    idSubjekta,
    idMjereOsobe,
    idMjereSubjekta
  ) => {
    e.preventDefault();
    this.setState({ ...this.state, datBrisanja: datBrisanja });
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    const { datBrisanja } = this.state;

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      //obavezna polja i ispis poruka
      const { datBrisanja } = this.state;

      if (!datBrisanja) {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite datum brisanja!");
        this.setState({ modalDatBrisanja: true });
        return;
      } else {
        try {
          const { datBrisanja } = this.state;
          const { idMjereSubjekta } = this.state;
          const { idSubjekta } = this.state;

          axiosInstance
            .patch(
              `/controlMeasures/unosDatBrisanjaPerson?idMjereOsobe=${idMjereSubjekta}`,
              { datBrisanja: datBrisanja, idMjereOsobe: idMjereSubjekta }
            )
            .then((res) => {
              this.setState({ modalDatBrisanja: false, table: true });
              this.showTable(idSubjekta);
            });
        } catch (e) {
          throw e;
        }

        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDatBrisanja: false, table: true });
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      //obavezna polja i ispis poruka
      const { datBrisanja } = this.state;
      const { idSubjekta } = this.state;

      if (!datBrisanja) {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Unesite datum brisanja!");
        this.setState({ modalDatBrisanja: true });
        return;
      } else {
        try {
          const { datBrisanja } = this.state;
          const { idMjereSubjekta } = this.state;
          const { idSubjekta } = this.state;

          axiosInstance
            .patch(
              `/controlMeasures/unosDatBrisanjaDrustvo?idMjereDrustva=${idMjereSubjekta}`,
              { datBrisanja: datBrisanja, idMjereDrustva: idMjereSubjekta }
            )
            .then((res) => {
              this.setState({ modalDatBrisanja: false, table: true });
              this.showTable(idSubjekta);
            });
        } catch (e) {
          throw e;
        }
        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDatBrisanja: false, table: true });
      }
      this.showTable(idSubjekta);
    }
  };

  //unos DATUMA DOSTAVLJANJA RJESENJA
  submitHandlerDatDostaveRjesenja = async (
    e,
    idSubjekta,
    idMjereOsobe,
    idMjereSubjekta
  ) => {
    e.preventDefault();
    this.setState({ ...this.state, datPreuzimanja: datPreuzimanja });
    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    const { datPreuzimanja } = this.state;

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      //obavezna polja i ispis poruka
      const { datPreuzimanja } = this.state;

      if (!datPreuzimanja) {
        this.setState({ error: true });
        this.props.formSubmitError(
          true,
          "Unesite datum dostave rješenja subjektu!"
        );
        this.setState({ modalDatDostave: true });
        return;
      } else {
        try {
          const { datPreuzimanja } = this.state;
          const { idMjereSubjekta } = this.state;
          const { idSubjekta } = this.state;

          axiosInstance
            .patch(
              `/controlMeasures/unosDatDostavePerson?idMjereOsobe=${idMjereSubjekta}`,
              { datPreuzimanja: datPreuzimanja, idMjereOsobe: idMjereSubjekta }
            )
            .then((res) => {
              this.setState({ modalDatDostave: false, table: true });
              this.showTable(idSubjekta);
            });
        } catch (e) {
          throw e;
        }

        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDatDostave: false, table: true });
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      //obavezna polja i ispis poruka
      const { datPreuzimanja } = this.state;
      const { idSubjekta } = this.state;

      if (!datPreuzimanja) {
        this.setState({ error: true });
        this.props.formSubmitError(
          true,
          "Unesite datum dostave rješenja subjektu!"
        );
        this.setState({ modalDatDostave: true });
        return;
      } else {
        try {
          const { datPreuzimanja } = this.state;
          const { idMjereSubjekta } = this.state;
          const { idSubjekta } = this.state;

          axiosInstance
            .patch(
              `/controlMeasures/unosDatDostaveDrustvo?idMjereDrustva=${idMjereSubjekta}`,
              {
                datPreuzimanja: datPreuzimanja,
                idMjereDrustva: idMjereSubjekta,
              }
            )
            .then((res) => {
              this.setState({ modalDatDostave: false, table: true });
              this.showTable(idSubjekta);
            });
        } catch (e) {
          throw e;
        }
        this.props.formSubmitSuccess(false, "Podaci su uspješno upisani!");
        this.setState({ modalDatDostave: false, table: true });
      }
      this.showTable(idSubjekta);
    }
  };

  clearSearch = () => {
    this.setState({
      ...this.state,
      oib: "",
      regNumber: "",
      subjectName: "",
      nameSurname: "",
      surName: "",
      class: "",
      mbs: "",
    });
    document.getElementById("form").reset();
    // window.location.reload();
  };

  obrisiMjeru = (
    e,
    idMjereSubjekta,
    idSubjekta,
    idMjereOsobe,
    idMjereDrustva,
    idOsobe,
    idDrustva
  ) => {
    e.preventDefault();

    const findIdSubjekta = this.state.revisorData.find(
      (element) => element.idSubjekta === this.state.idSubjekta
    );

    if (findIdSubjekta.tipSubjekta === "OSOBA") {
      try {
        this.setState({
          ...this.state,
          loaderBrisanje: true,
          idSubjekta: idOsobe,
          idMjereSubjekta: idMjereOsobe,
        });
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/deaktivacijaMjereOsoba?idMjereOsobe=${idMjereSubjekta}&idOsobe=${idSubjekta}&vrOsobe=${findIdSubjekta.vrstaRegistra}`
          )
          .then((res) => {
            this.setState(
              {
                idSubjekta: res.data,
              },
              () => {
                axiosInstance
                  .get(
                    `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=${this.state.pageNumber}&offset=10`
                  )
                  .then((res) => {
                    this.setState(
                      {
                        revisorData: res.data,
                        totalPageCount: res.data[0].totalRows,
                        error: false,
                        isListLoading: false,
                        modalObrisi: false,
                        loaderBrisanje: false,
                      },
                      () => {
                        this.props.formSubmitSuccess(
                          false,
                          "Nadzorna mjera je uspješno obrisana!"
                        );
                        this.showTable(this.state.idSubjekta);
                        this.showTableDeleted(this.state.idSubjekta);
                      }
                    );
                  });
              }
            );
          });
      } catch (e) {
        this.setState(
          {
            loaderBrisanje: false,
          },
          () => {
            this.props.formSubmitSuccess(false, "Nešto je pošlo po krivu!");
          }
        );
      }
    } else if (findIdSubjekta.tipSubjekta === "DRUSTVO") {
      try {
        this.setState({
          ...this.state,
          loaderBrisanje: true,
          idSubjekta: idDrustva,
          idMjereSubjekta: idMjereDrustva,
        });
        const { idMjereSubjekta } = this.state;
        const { idSubjekta } = this.state;

        axiosInstance
          .patch(
            `/controlMeasures/deaktivacijaMjereDrustvo?idMjereDrustva=${idMjereSubjekta}&idDrustva=${idSubjekta}&vrDrustva=${findIdSubjekta.vrstaRegistra}`
          )
          .then((res) => {
            this.setState(
              {
                idSubjekta: res.data,
              },
              () => {
                axiosInstance
                  .get(
                    `/controlMeasures/search/request?oib=${this.state.oib}&regBroj=${this.state.regNumber}&nazSubjekta=${this.state.subjectName}&ime=${this.state.nameSurname}&prezime=${this.state.surName}&klasa=${this.state.class}&mbs=${this.state.mbs}&page=${this.state.pageNumber}&offset=10`
                  )
                  .then((res) => {
                    this.setState(
                      {
                        revisorData: res.data,
                        totalPageCount: res.data[0].totalRows,
                        error: false,
                        isListLoading: false,
                        modalObrisi: false,
                        loaderBrisanje: false,
                      },
                      () => {
                        this.props.formSubmitSuccess(
                          false,
                          "Nadzorna mjera je uspješno obrisana!"
                        );
                        this.showTable(this.state.idSubjekta);
                        this.showTableDeleted(this.state.idSubjekta);
                      }
                    );
                  });
              }
            );
          });
      } catch (e) {
        this.setState(
          {
            loaderBrisanje: false,
          },
          () => {
            this.props.formSubmitSuccess(false, "Nešto je pošlo po krivu!");
          }
        );
      }
    }
  };

  getAttachment = async (e, idMjereSubjekta) => {
    e.preventDefault();

    await axiosInstance
      .get(
        `/controlMeasures/obrisiMjeruDrustvo?idMjereDrustva=${idMjereSubjekta}`
      )
      .then((res) => {});

    this.openModalDodavanje(e);
  };

  render() {
    const { isAuthenticated, userData } = this.props;
    const userRole = userData != null ? userData.roles[0].roleName : null;

    return (
      <>
        {this.props.role != "ROLE_KORISNIK" ? (
          <ControlMeasureSearch
            {...this.state}
            userInputHandler={this.userInputHandler}
            onSubmit={this.submitHandlerSearch}
            clearSearch={this.clearSearch}
          />
        ) : (
          ""
        )}

        {this.state.revisorData && this.state.revisorData.length > 0 && (
          <div className="mb-3" style={{ paddingTop: "30px" }}>
            <Row className="justify-content-center">
              <Col lg={12} md={12} className="align-self-center">
                <Table responsive bordered hover>
                  <thead>
                    <tr className="tr_table">
                      <th scope="col">Vrsta registra</th>
                      <th scope="col">Status</th>
                      <th scope="col">OIB / Identifikacijski broj</th>
                      <th scope="col">Registarski broj</th>
                      <th scope="col">Revizorsko društvo</th>
                      <th scope="col">Ime i prezime</th>
                      <th scope="col">Adresa</th>
                      <th scope="col">Akcija </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.isLoading ? (
                      <tr>
                        <td colSpan="9">
                          <Container
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <Row style={{ justifyContent: "center" }}>
                              <Col style={{ alignItems: "center" }}>
                                <Spinner
                                  animation="border"
                                  variant="secondary"
                                  style={{
                                    marginTop: "16px",
                                    marginBottom: "16px",
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div
                                  style={{
                                    marginTop: "16px",
                                    marginLeft: "16px",
                                  }}
                                  className="spin-text"
                                >
                                  <b>Učitavam...</b>
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {this.state.revisorData.map((element, index) => (
                          <tr key={`tr-${index}`} className="row-tr">
                            {/* nije najbolje rjesenje za ovo, ako stignem prebacim na beckend */}
                            <td>
                              {(element.tipSubjekta === "OSOBA" &&
                                element.vrstaRegistra === 1 &&
                                "Ovlašteni revizor") ||
                                (element.tipSubjekta === "OSOBA" &&
                                  element.vrstaRegistra === 3 &&
                                  "Revizor iz druge zemlje") ||
                                (element.tipSubjekta === "OSOBA" &&
                                  element.vrstaRegistra === 4 &&
                                  "Revizor iz treće zemlje") ||
                                (element.tipSubjekta === "OSOBA" &&
                                  element.vrstaRegistra === 5 &&
                                  "Revizor u trećoj zemlji") ||
                                (element.tipSubjekta === "DRUSTVO" &&
                                  element.vrstaRegistra === 1 &&
                                  "Revizorsko društvo") ||
                                (element.tipSubjekta === "DRUSTVO" &&
                                  element.vrstaRegistra === 2 &&
                                  "Samostalni revizor") ||
                                (element.tipSubjekta === "DRUSTVO" &&
                                  element.vrstaRegistra === 3 &&
                                  "Revizorsko društvo iz druge zemlje") ||
                                (element.tipSubjekta === "DRUSTVO" &&
                                  element.vrstaRegistra === 4 &&
                                  "Subjekt u trećoj zemlji")}
                            </td>
                            <td>
                              {element.oznAkt == 1 ? (
                                <Badge pill variant="success">
                                  Aktivan
                                </Badge>
                              ) : (
                                <Badge pill variant="danger">
                                  Brisan
                                </Badge>
                              )}
                            </td>

                            <td>
                              {element.oib ? element.oib : element.idBroj}
                            </td>
                            <td>{element.regBroj}</td>

                            <td>{element.nazSubjekta}</td>
                            <td>
                              {element.ime && element.prezime
                                ? element.ime + " " + element.prezime
                                : "-"}
                            </td>
                            {/* {element.tipSubjekta === "OSOBA" || element.tipSubjekta === "DRUSTVO" && element.ime ? (
                      <td>{element.ime}</td> ) : (<td>-</td>)}
                      {element.tipSubjekta === "OSOBA" || element.tipSubjekta === "DRUSTVO" && element.prezime ? (
                      <td>{element.prezime}</td> ) : (<td>-</td>)} */}
                            <td>
                              {element.ulicaKbrHr
                                ? element.ulicaKbrHr != null &&
                                  element.ulicaKbrHr + ", "
                                : element.ulicaKbr != null &&
                                  element.ulicaKbr + ", "}
                              {element.nazNaseljaHr
                                ? element.nazNaseljaHr != null &&
                                  element.nazNaseljaHr + ", "
                                : element.nazNaselja != null &&
                                  element.nazNaselja + ", "}
                              {element.nazDrzaveHr
                                ? element.nazDrzaveHr != null &&
                                  element.nazDrzaveHr
                                : element.nazDrzave != null &&
                                  element.nazDrzave}
                            </td>

                            <td className="ant_batn">
                              <ButtonComponent
                                variant="secondary"
                                //size="small"
                                //size="sm"
                                onClick={(e) => {
                                  this.showTable(element.idSubjekta);
                                  this.showTableDeleted(element.idSubjekta);
                                  this.openModalPregled(
                                    element.idSubjekta,
                                    element.vrstaRegistra
                                  );
                                }}
                              >
                                <FormOutlined />
                              </ButtonComponent>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                  {/* ovdje završava provjera postoje li revisorData
                   */}
                </Table>
              </Col>
            </Row>

            <div className="pagination_div">
              <Pagination
                defaultCurrent={1}
                defaultPageSize={10}
                total={this.state.totalPageCount}
                responsive
                onChange={this.pageChanged}
                showSizeChanger={false}
              />
            </div>
          </div>
          // završava provjera za revisor data
        )}

        {this.state.revisorData.length === 0 && (
          <>
            <div className="mb-3" style={{ paddingTop: "30px" }}>
              <Row className="justify-content-center">
                <Col lg={12} md={12} className="align-self-center">
                  <Table responsive bordered hover>
                    <thead>
                      <tr className="tr_table">
                        <th scope="col">Vrsta registra</th>
                        <th scope="col">Status</th>
                        <th scope="col">OIB / Identifikacijski broj</th>
                        <th scope="col">Registarski broj</th>
                        <th scope="col">Revizorsko društvo</th>
                        <th scope="col">Ime i prezime</th>
                        <th scope="col">Adresa</th>
                        <th scope="col">Akcija </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="9">
                          {this.state.isLoading ? (
                            <Container
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Row style={{ justifyContent: "center" }}>
                                <Col style={{ alignItems: "center" }}>
                                  <Spinner
                                    animation="border"
                                    variant="secondary"
                                    style={{
                                      marginTop: "16px",
                                      marginBottom: "16px",
                                    }}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div
                                    style={{
                                      marginTop: "16px",
                                      marginLeft: "16px",
                                    }}
                                    className="spin-text"
                                  >
                                    <b>Učitavam...</b>
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          ) : (
                            <i>Nema unesenih podataka u registar.</i>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          </>
        )}

        <ControlMeasuresPregled
          {...this.state}
          hideModalPregled={this.hideModalPregled}
          userInputHandler={this.userInputHandler}
          userInputFormHandler={this.userInputFormHandler}
          datePickerHandler={this.datePickerHandler}
          openModal={this.openModal}
          hideModal={this.hideModal}
          mjereDropDownHandler={this.mjereDropDownHandler}
          uploadHandler={this.uploadHandler}
          submitHandler={this.submitHandler}
          submitHandlerDat={this.submitHandlerDat}
          downloadDocument={this.downloadDocument}
          openModalDatPravomocnosti={this.openModalDatPravomocnosti}
          hideModalDat={this.hideModalDat}
          userRole={userRole}
          obrisiMjeru={this.obrisiMjeru}
          openModalObrisi={this.openModalObrisi}
          hideModalObrisi={this.hideModalObrisi}
          userInputFormHandlerUS={this.userInputFormHandlerUS}
          datePickerHandlerUS={this.datePickerHandlerUS}
          uploadHandlerUS={this.uploadHandlerUS}
          downloadDocumentUS={this.downloadDocumentUS}
          openModalUpravniSpor={this.openModalUpravniSpor}
          hideModalUpravniSpor={this.hideModalUpravniSpor}
          submitHandlerUS={this.submitHandlerUS}
          downloadDocumentPP={this.downloadDocumentPP}
          userInputFormHandlerPP={this.userInputFormHandlerPP}
          datePickerHandlerPP={this.datePickerHandlerPP}
          uploadHandlerPP={this.uploadHandlerPP}
          openModalPP={this.openModalPP}
          hideModalPP={this.hideModalPP}
          submitHandlerPP={this.submitHandlerPP}
          openModalUnosDatBrisanja={this.openModalUnosDatBrisanja}
          hideModalUnosDatBrisanja={this.hideModalUnosDatBrisanja}
          datePickerHandlerDB={this.datePickerHandlerDB}
          submitHandlerDatBrisanja={this.submitHandlerDatBrisanja}
          submitHandlerDatDostaveRjesenja={this.submitHandlerDatDostaveRjesenja}
          openModalUnosDatDostave={this.openModalUnosDatDostave}
          hideModalUnosDatDostave={this.hideModalUnosDatDostave}
          datePickerHandlerDD={this.datePickerHandlerDD}
          openModalNapomena={this.openModalNapomena}
          hideModalNapomena={this.hideModalNapomena}
          userInputNapomena={this.userInputNapomena}
          submitHandlerNapomena={this.submitHandlerNapomena}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};
const mapStateToProps = (state) => {
  return {
    userData: state.authentication.userData,
    isAuthenticated: state.authentication.isAuthenticated,
    role: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(controlMeasures);
